<template>
  <div>
    <div class="row">
      <div class="col-md-5 mx-auto pt-3">
        <div id="first">
          <div class="myform form">
            <div class="logo mb-3">
              <div class="col-md-12 text-center rounded bg-primary p-4">
                <h1>{{ $t("Signup") }}</h1>
              </div>
            </div>
            <div class="form-group mx-4">
              <label for="exampleInputEmail1">{{ $t("Name") }}</label>
              <input
                type="text"
                name="FullName"
                class="form-control"
                v-model="Model.name"
                v-validate="'required'"
                aria-describedby="name"
                :data-vv-as="$t('Name')"
                placeholder="Enter Firstname"
              />
              <span class="text-danger">{{ errors.first("Name") }}</span>
            </div>
            <div class="form-group mx-4">
              <label for="exampleInputEmail1">{{ $t("PhoneNumber") }}</label>
              <input
                type="text"
                name="Phone"
                v-model="Model.telephone"
                class="form-control"
                v-validate="'required'"
                :data-vv-as="$t('PhoneNumber')"
                aria-describedby="name"
                placeholder="Enter Phone"
              />
              <span class="text-danger">{{ errors.first("PhoneNumber") }}</span>
            </div>
            <div class="form-group mx-4">
              <label for="exampleInputEmail1">{{ $t("Email") }}</label>
              <input
                type="email"
                name="Email"
                class="form-control"
                v-model="Model.email"
                v-validate="'required|email'"
                :data-vv-as="$t('Email')"
                aria-describedby="emailHelp"
                placeholder="Enter email"
              />
              <span class="text-danger">{{ errors.first("Email") }}</span>
            </div>
            <hr />
            <div class="form-group mx-4">
              <label for="exampleInputEmail1">{{ $t("Password") }}</label>
              <input
                type="password"
                name="Password"
                v-validate="'required|min:6|lowCase|UpCase'"
                v-model="Model.password"
                :data-vv-as="$t('Password')"
                class="form-control"
                ref="password"
                aria-describedby="emailHelp"
                placeholder="Enter Password"
              />
              <span class="text-danger">{{ errors.first("Password") }}</span>
            </div>
            <div class="form-group mx-4">
              <label for="exampleInputEmail1">{{
                $t("ConfirmPassword")
              }}</label>
              <input
                type="password"
                name="ConfirmPassword"
                v-model="ConfirmPassword"
                v-validate="'required|confirmed:password|min:6|lowCase|UpCase'"
                :data-vv-as="$t('ConfirmPassword')"
                class="form-control"
                aria-describedby="emailHelp"
                placeholder="Enter Password"
              />
              <span class="text-danger">{{
                errors.first("ConfirmPassword")
              }}</span>
            </div>

            <div class="col-md-12 text-center mt-4">
              <button
                @click="Register"
                :disabled="!validateForm"
                class="
                  rounded-pill
                  text-white
                  btn btn-primary btn-block
                  mybtn
                  tx-tfm
                "
              >
                {{ $t("GetStartedForFree") }}
              </button>
            </div>
            <div class="col-md-12 mt-2">
              <div class="form-group mx-4">
                <p class="text-center">
                  <span id="signin"
                    >{{ $t("AlreadyHaveAnAccount") }}
                    <router-link to="/login">
                      <a
                        class="text-primary"
                        :to="{
                          name: 'login',
                        }"
                        >{{ $t("Login") }}</a
                      >
                    </router-link>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Model: {
        name: "",
        email: "",
        telephone: "",
        password: "",
        profilePic: "",
        fireBaseToken: "",
      },
      ConfirmPassword: "",
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.Model.name !== "" &&
        this.Model.email !== "" &&
        this.Model.telephone !== "" &&
        this.Model.password !== "" &&
        this.Model.password == this.ConfirmPassword &&
        this.ConfirmPassword !== ""
      );
    },
  },

  methods: {
    Register() {
      debugger;
      this.$store.dispatch("auth/Register", this.Model);
    },
  },
  created() {
    debugger;
  },
};
</script>
